<template>
    <div class="row d-flex">
        <div class="col-md-6">
            <div class="p-3 bg-white shadow-sm rounded-lg">
                <auth></auth>
            </div>
        </div>

        <div class="col-md-6 flex-fill">
            <password></password>
        </div>
    </div>
</template>

<script>
import Password from "./Password";
import Auth from "./Auth";

export default {
    name: "Profile",
    components: {Auth, Password},
    computed: {
        user() {
            return JSON.parse(localStorage.getItem('user'))
        }
    },
}
</script>

<style scoped>

</style>